// extracted by mini-css-extract-plugin
export default {"root":"VideoLocalPlayer_root__9tAsL","video":"VideoLocalPlayer_video__MyatM"};